import Vue from 'vue';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import './index.css';
import './styleLib';

Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.directive('title', {
  componentUpdated: (el) => {
    // console.log('---------', el.dataset.title);
    const { title } = el.dataset;
    document.querySelector('title').innerText = title;
    document.title = title;
    const pt = document.querySelector('#pageTitle');
    if (pt) {
      pt.innerText = title || '';
    }
  },
});
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
Vue.prototype.$cookies.config(1000 * 60 * 30);
